import React, { useRef } from 'react';


export default function OTPInputScreen({ length = 4, onChange }) {
  const inputs = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value)) {
      onChange((prev) => {
        const updated = [...prev];
        updated[index] = value;
        return updated;
      });
      // Focus next input
      if (index < length - 1) {
        inputs.current[index + 1].focus();
      }
    } else if (value === '') {
      onChange((prev) => {
        const updated = [...prev];
        updated[index] = '';
        return updated;
      });
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !e.target.value && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      {Array.from({ length }).map((_, i) => (
        <input
          key={i}
          type="text"
          inputMode="numeric"
          maxLength={1}
          ref={(el) => (inputs.current[i] = el)}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          style={{
            width: '55px',
            height: '55px',
            textAlign: 'center',
            fontSize: '18px',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}
        />
      ))}
    </div>
  );
};